import '.fl{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fm{padding-left:1.5rem;}.ssr-plugin'
import '.fn{margin:1rem 0;}.ssr-plugin'
import '.fo{color:var(--gray-700);}.ssr-plugin'
import '.fp{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fl fm fn fo fp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
